import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { LayoutDashboardIcon, SearchIcon, LineChartIcon, FileTextIcon, MenuIcon, CalendarIcon, BriefcaseIcon, BellIcon, ArrowLeftIcon, ClipboardListIcon, FolderOpenIcon } from 'lucide-react';
interface ClientPortalLayoutProps {
  children: React.ReactNode;
}
export function ClientPortalLayout({
  children
}: ClientPortalLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navItems = [{
    label: 'Offsite Overview',
    path: '/client-portal',
    icon: LayoutDashboardIcon,
    exact: true
  }, {
    label: 'Diagnostic Intake',
    path: '/client-portal/diagnostic',
    icon: ClipboardListIcon
  }, {
    label: 'Offsite Brief',
    path: '/client-portal/brief',
    icon: FileTextIcon
  }, {
    label: 'Agenda Builder',
    path: '/client-portal/agenda',
    icon: CalendarIcon
  }, {
    label: 'Deliverables Center',
    path: '/client-portal/deliverables',
    icon: FolderOpenIcon
  }, {
    label: 'Outcomes Dashboard',
    path: '/client-portal/outcomes',
    icon: LineChartIcon
  }];
  return <div className="min-h-screen bg-stone-50 flex font-sans text-slate-800" data-id="element-291">
      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && <div className="fixed inset-0 bg-slate-900/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} data-id="element-292" />}

      {/* Sidebar */}
      <aside className={`fixed inset-y-0 left-0 z-50 w-64 bg-[#0B1B3B] text-white flex flex-col transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:shrink-0 border-r border-slate-800 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`} data-id="element-293">
        {/* Brand Header */}
        <div className="p-6 border-b border-white/10" data-id="element-294">
          <div className="font-serif-display text-2xl font-bold tracking-tight mb-1" data-id="element-295">
            Offsite+
          </div>
          <div className="text-[10px] font-bold text-amber-500 uppercase tracking-[0.2em]" data-id="element-296">
            Client Portal
          </div>
        </div>

        {/* Client Selector */}
        <div className="p-4 border-b border-white/10" data-id="element-297">
          <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-white/5 transition-colors cursor-pointer" data-id="element-298">
            <div className="w-10 h-10 rounded bg-white/10 flex items-center justify-center shrink-0" data-id="element-299">
              <BriefcaseIcon className="w-5 h-5 text-amber-500/80" data-id="element-300" />
            </div>
            <div className="overflow-hidden" data-id="element-301">
              <div className="font-bold text-sm truncate" data-id="element-302">
                Helix Therapeutics
              </div>
              <div className="text-xs text-slate-400 truncate" data-id="element-303">
                Leadership Team
              </div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1" data-id="element-304">
          {navItems.map(item => <NavLink key={item.label} to={item.path} end={item.exact} className={({
          isActive
        }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-amber-500/10 text-amber-500 border-l-2 border-amber-500' : 'text-slate-300 hover:bg-white/5 hover:text-white border-l-2 border-transparent'}`} data-id="element-305">
              <item.icon className="w-4 h-4 shrink-0" data-id="element-306" />
              {item.label}
            </NavLink>)}
        </nav>

        {/* Footer Link */}
        <div className="p-4 border-t border-white/10" data-id="element-307">
          <Link to="/" className="flex items-center gap-2 text-xs font-medium text-amber-500/80 hover:text-amber-500 transition-colors" data-id="element-308">
            <ArrowLeftIcon className="w-3.5 h-3.5" data-id="element-309" />
            Back to Public Site
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0" data-id="element-310">
        {/* Top Bar */}
        <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 lg:px-8 sticky top-0 z-30" data-id="element-311">
          <div className="flex items-center gap-4 flex-1" data-id="element-312">
            <button className="lg:hidden p-2 -ml-2 text-slate-500 hover:text-slate-800" onClick={() => setSidebarOpen(true)} data-id="element-313">
              <MenuIcon className="w-5 h-5" data-id="element-314" />
            </button>
            <div className="relative max-w-md w-full hidden sm:block" data-id="element-315">
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-316" />
              <input type="text" placeholder="Search resources, agendas..." className="w-full pl-9 pr-4 py-2 bg-slate-50 border-none rounded-lg text-sm focus:ring-2 focus:ring-amber-500/20 focus:bg-white transition-colors outline-none" data-id="element-317" />
            </div>
          </div>
          <div className="flex items-center gap-4 shrink-0" data-id="element-318">
            <button className="p-2 text-slate-400 hover:text-slate-600 relative" data-id="element-319">
              <BellIcon className="w-5 h-5" data-id="element-320" />
              <span className="absolute top-2 right-2 w-1.5 h-1.5 bg-rose-500 rounded-full border border-white" data-id="element-321" />
            </button>
            <div className="w-8 h-8 rounded-full bg-[#0B1B3B] text-white flex items-center justify-center text-xs font-bold" data-id="element-322">
              HT
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-x-hidden" data-id="element-323">{children}</main>
      </div>
    </div>;
}